var _line, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 8.80155,
    x2: 20,
    y2: 32.1349,
    stroke: "#111111",
    strokeWidth: 3.33333,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1725 24.1346C31.8201 23.4805 31.8201 22.4199 31.1725 21.7657C30.525 21.1116 29.475 21.1116 28.8275 21.7657L31.1725 24.1346ZM11.1725 21.7657C10.525 21.1116 9.47503 21.1116 8.82746 21.7657C8.17988 22.4199 8.17988 23.4805 8.82746 24.1346L11.1725 21.7657ZM28.8275 21.7657L19.1206 31.5711L21.4657 33.94L31.1725 24.1346L28.8275 21.7657ZM20.8794 31.5711L11.1725 21.7657L8.82746 24.1346L18.5343 33.94L20.8794 31.5711ZM19.1206 31.5711C19.6063 31.0805 20.3937 31.0805 20.8794 31.5711L18.5343 33.94C19.3438 34.7577 20.6562 34.7577 21.4657 33.94L19.1206 31.5711Z",
    fill: "#111111"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.4c1d82d39d474980a8a255c28eb7d787.svg";
export { ForwardRef as ReactComponent };